// NOTE: 공항권 관련 시나리오
import push from '@/utils/gaEvents/push'

const renderAirportStart = () => {
  push({
    event: 'preBooking_구매시작'
  } satisfies GtagAirportEvent)
}

const renderAirportTicketList = (cgSeq: number, result: number, startTime: string, endTime: string) => {
  push({
    event: 'preBooking_검색결과',
    cgSeq: cgSeq,
    startTime: startTime,
    endTime: endTime,
    result: result
  } satisfies GtagAirportEvent)
}

const renderAirportTicketDetail = (pklSeq: number, pklName: string, couponSeq: number, couponName: string) => {
  push({
    event: 'preBooking_주차권상세',
    pklSeq: pklSeq,
    pklName: pklName,
    couponSeq: couponSeq,
    couponName: couponName
  } satisfies GtagAirportEvent)
}

const renderAirportPayment = (pklSeq: number, pklName: string, couponSeq: number, couponName: string) => {
  push({
    event: 'preBooking_결제수단선택',
    pklSeq: pklSeq,
    pklName: pklName,
    couponSeq: couponSeq,
    couponName: couponName
  } satisfies GtagAirportEvent)
}

const renderAirportPaymentComplete = (
  pklSeq: number,
  pklName: string,
  couponSeq: number,
  couponName: string,
  paymentSeq: number
) => {
  push({
    event: 'preBooking_구매완료',
    pklSeq: pklSeq,
    pklName: pklName,
    couponSeq: couponSeq,
    couponName: couponName,
    paymentSeq: paymentSeq
  } satisfies GtagAirportEvent)
}

const clickUserInfoCompleteButton = () => {
  push({
    event: 'preBooking_정보입력완료'
  } satisfies GtagAirportEvent)
}

const airportEvent = {
  renderAirportStart,
  renderAirportTicketList,
  renderAirportTicketDetail,
  renderAirportPayment,
  renderAirportPaymentComplete,
  clickUserInfoCompleteButton
}

export default airportEvent
